import { render, staticRenderFns } from "./newMunkalap.vue?vue&type=template&id=cb3a9ef2&scoped=true"
import script from "./newMunkalap.vue?vue&type=script&lang=js"
export * from "./newMunkalap.vue?vue&type=script&lang=js"
import style0 from "./newMunkalap.vue?vue&type=style&index=0&id=cb3a9ef2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_cache-loader@4.1.0_webpack@4.47.0__css-load_37b6f71ccdfa7d6e81ff3b7ec2a43a31/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3a9ef2",
  null
  
)

export default component.exports